$(document).ready(function () {
    const newsModule = $('#ritzauNews');
    const newsNav = $('.news-nav');
    const toggles = $('.accordion-toggle');
    const sections = $('.module-news-section');
    const search = $('.js-search-news');

    if (newsModule && typeof URL !== 'undefined') {
        // Remove query parameters from URL on page load
        const url = new URL(window.location.toString());
        var currentPage = url.searchParams.has('page') ? parseInt(url.searchParams.get('page')) : 1;
        var currentSearch = url.searchParams.get('search');
        url.searchParams.delete('page');
        url.searchParams.delete('search');
        window.history.replaceState({}, '', url);

        newsNav.click(function(){
            const index = $(this).attr('data-page');
            filterNews(index);
        });

        toggles.click(function() {
            const target = $(this).attr('data-target');
            const targetElement = $(`[data-id='${target}']`);

            if (targetElement) {
                toggles.removeClass('active');
                $(this).addClass('active');
                sections.hide();
                targetElement.show();
            }
        });

        search.submit(function(e) {
            e.preventDefault();
            const searchTerm = search.find('input').val();
            window.location.href = url + '?search=' + encodeURIComponent(searchTerm);
        });

        function filterNews(index) {
            const url = new URL(window.location.toString());

            if (index === '-') {
                url.searchParams.set('page', currentPage - 1);
            } else if (index === '+') {
                url.searchParams.set('page', currentPage + 1);
            } else {
                url.searchParams.set('page', index);
            }
            
            if (currentSearch) {
                url.searchParams.set('search', currentSearch);
            }
            window.history.pushState({}, '', url);
            window.history.go();
        };
    }
});